// src/components/DatabaseExplorer/databaseExplorerConfig.js

const API_BASE = process.env.REACT_APP_URL_PREFIX || "";

export const API_CONFIG = {
  describeUrl: `${API_BASE}describe/`,
  fetchUrl: `${API_BASE}getDynamicDataForTwoDate?table_name=`,
  // "https://railsetu.in:5000/getDynamicDataForTwoDate?table_name=t_indent_hdr&date_column=created_at&from_date=2026-01-11&to_date=2026-07-7&action=due&order_by=id&order_type=DESC&limit=1&database_name=railsetu"
  databaseParam: "database",
  tableParam: "table",

  extraParams: {},
};

// Replace example tables with your actual tables.
export const DATABASE_TABLES = {
  store: ["m_commodity", "m_store_item_master"],

  railsetu: [
    // Add your actual RailSetu tables.
  ],

  blocks: [{ table: "block_data", date_column: "reportDate" }],
  cris_api_data: [
    { table: "icms_report16", date_column: "reportDate" },
    { table: "icms_report16_detention", date_column: "reportDate" },
    { table: "report02_train_punctuality", date_column: "report_date" },
  ],
};
